<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form  class="form-inline my-2 my-lg-0">
                    <button @click="showSheetType(null)"
                        class="btn btn-warning my-2 my-sm-0"
                        type="button">
                        <icon name="plus"></icon> เพิ่มประเภทชีท
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อประเภทชีท</th>
                    <th>แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in sheet_type">
                    <td>{{++index}}</td>
                    <td>{{data.name}}</td>
                    <td>
                        <a @click="showSheetType(data)"><icon name="pencil-alt"></icon></a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="add_type">
            <sheet-type-information-modal :form="form" @submit="saveSheetType">
            </sheet-type-information-modal>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import SheetTypeInformationModal from "./SheetTypeInformationModal";

    export default {
        name: "SheetTypeList",
        components: {SheetTypeInformationModal},
        created() {
            this.getSheetTypeTable();
        },
        data(){
          return{
              form : {
                  id : '',
                  name : '',
              }
          }
        },
        computed: {
            ...mapState({
                sheet_type: state => {
                    return state.Sheet.sheet_type;
                },
            })
        },
        methods:{
            getSheetTypeTable(){
                this.$store.dispatch("Sheet/getSheetTYPE");
            },
            showSheetType(data){
                if(data){
                    this.form = data;
                }
                this.$refs.add_type.show();
            },
            hideSheetType(){
                this.$refs.add_type.hide();
            },
            saveSheetType(value){
                if(value){
                    this.$store.dispatch("Sheet/saveSheetType",value).then(()=>{
                        this.getSheetTypeTable();
                    })
                }
                this.form = {
                    id : '',
                    name : ''
                }
                this.hideSheetType();
            },
        }
    }
</script>

<style scoped>

</style>
